import { JobSiteFormData } from '../types/JobSiteTypes';
import { mapFormDataToUpdateInput } from '../mappers/JobSiteMappers';
import { useUpdateJobSiteMutation } from '@/common/infrastructure/gql/generated/schema';
import { useApolloClient } from '@apollo/client';

export const useUpdateJobSite = () => {
  const [updateJobSite, { data, loading, error }] = useUpdateJobSiteMutation();
  const apolloClient = useApolloClient();

  const handleUpdateJobSite = async (formData: JobSiteFormData) => {
    try {
      const mutationInput = mapFormDataToUpdateInput(formData);
      await updateJobSite({
        variables: { input: mutationInput },
        refetchQueries: ['listJobSites', 'getJobSite'],
        awaitRefetchQueries: true
      });

      // Also invalidate the cache to ensure fresh data when component mounts
      // This handles the case when navigating back from details page
      // and the grid component is not mounted yet
      apolloClient.cache.evict({ fieldName: 'jobSites' });
      apolloClient.cache.gc();
    } catch (err) {
      console.error('Error updating jobSite:', err);
      throw err;
    }
  };

  return { handleUpdateJobSite, data, loading, error };
};
